import {
  INFO_LAB_REQUEST,
  INFO_LAB_SUCCESS,
  INFO_LAB_FAIL,
} from "../../constants/labInfo_constant";

import axios from "axios";
import { BASE_URL } from "../../axios/serverURL";
export const getInfoLab = (id_patient) => async (dispatch, getState) => {
  try {
    dispatch({ type: INFO_LAB_REQUEST });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "lab",
      action: "info",
    };
    const { data } = await axios.post(BASE_URL, inputs);
    dispatch({
      type: INFO_LAB_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: INFO_LAB_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
